import { type Lookup } from '@/models/Lookup';

export const constants = {
  SCROLL_THRESHOLD: 270,
};

export const Lookups: Lookup[] = [
  { id: 2, code: 'PRLMNU', parentCode: 'PMLCTN', name: 'نيابية' },
  { id: 3, code: 'MUNCPMNU', parentCode: 'PMLCTN', name: 'بلدية' },
];

// Define the Map of Keys to Arabic Labels
export const religious: Record<string, string> = {
  sunni: 'سني',
  shia: 'شيعي',
  alawite: 'علوي',
  druze: 'درزي',
  maronite: 'ماروني',
  romanCatholic: 'روم كاثوليك',
  romanOrthodox: 'روم ارثوذكس',
  evangelical: 'انجيلي',
  armenianCatholic: 'أرمن كاثوليك',
  armenianOrthodox: 'أرمن ارثوذكس',
  minorities: 'أقليات',
} as const;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const religiousOptions = Object.entries(religious).map(([_, value], index) => ({
  id: index + 1,
  name: value,
}));

export const PollingLocatorSteps = ['مقيم \\ غير مقيم', 'معلومات شخصية', 'مركز الاقتراع'] as const;

export const continents = [
  {
    id: 1,
    name: 'افريقيا',
  },
  {
    id: 2,
    name: 'أنتاركتيكا',
  },
  {
    id: 3,
    name: 'آسيا',
  },
  {
    id: 4,
    name: 'أستراليا',
  },
  {
    id: 5,
    name: 'أوروبا',
  },
  {
    id: 6,
    name: 'أمريكا الشمالية',
  },
  {
    id: 7,
    name: 'أمريكا الجنوبية',
  },
] as const;

export const embassies = [
  {
    id: 1,
    name: 'البعثة الدبلوماسية الأفريقية ',
    continent: 1,
  },
  {
    id: 2,
    name: 'البعثة الدبلوماسية الأوروبية ',
    continent: 5,
  },
  {
    id: 3,
    name: 'البعثة الدبلوماسية الآسيوية ',
    continent: 3,
  },
  {
    id: 4,
    name: 'البعثة الدبلوماسية في أمريكا الجنوبية ',
    continent: 7,
  },
  {
    id: 5,
    name: 'البعثة الدبلوماسية في أمريكا الشمالية ',
    continent: 6,
  },
  {
    id: 6,
    name: 'البعثة الدبلوماسية الأسترالية ',
    continent: 4,
  },
  {
    id: 7,
    name: 'البعثة الدبلوماسية في أنتاركتيكا ',
    continent: 2,
  },
] as const;

export const cazas = [
  {
    id: 1,
    name: 'قضاء عكار',
  },
  {
    id: 2,
    name: 'قضاء بعلبك',
  },
  {
    id: 3,
    name: 'قضاء الهرمل',
  },
  {
    id: 4,
    name: 'قضاء راشيا',
  },
  {
    id: 5,
    name: 'قضاء البقاع الغربي',
  },
  {
    id: 6,
    name: 'قضاء زحلة',
  },
  {
    id: 7,
    name: 'قضاء جبيل',
  },
  {
    id: 8,
    name: 'قضاء كسروان',
  },
  {
    id: 9,
    name: 'قضاء عاليه',
  },
  {
    id: 10,
    name: 'قضاء بعبدا',
  },
  {
    id: 11,
    name: 'قضاء الشوف',
  },
  {
    id: 12,
    name: 'قضاء المتن',
  },
  {
    id: 13,
    name: 'قضاء بنت جبيل',
  },
  {
    id: 14,
    name: 'قضاء حاصبيا',
  },
  {
    id: 15,
    name: 'قضاء مرجعيون',
  },
  {
    id: 16,
    name: 'قضاء النبطية',
  },
  {
    id: 17,
    name: 'قضاء البترون',
  },
  {
    id: 18,
    name: 'قضاء بشري',
  },
  {
    id: 19,
    name: 'قضاء الكورة',
  },
  {
    id: 20,
    name: 'قضاء المنية الضنية',
  },
  {
    id: 21,
    name: 'قضاء طرابلس',
  },
  {
    id: 22,
    name: 'قضاء زغرتا',
  },
  {
    id: 23,
    name: 'قضاء صيدا',
  },
  {
    id: 24,
    name: 'قضاء جزين',
  },
  {
    id: 25,
    name: 'قضاء صور',
  },
  {
    id: 26,
    name: 'قضاء بيروت',
  },
] as const;

export const towns = [
  {
    id: 1,
    name: 'حلبا',
    cazaId: 1,
  },
  {
    id: 2,
    name: 'القبيات',
    cazaId: 1,
  },
  {
    id: 3,
    name: 'بعلبك',
    cazaId: 2,
  },
  {
    id: 4,
    name: 'دير الأحمر',
    cazaId: 2,
  },
  {
    id: 5,
    name: 'الهرمل',
    cazaId: 3,
  },
  {
    id: 6,
    name: 'القاع',
    cazaId: 3,
  },
  {
    id: 7,
    name: 'راشيا',
    cazaId: 4,
  },
  {
    id: 8,
    name: 'عين عطا',
    cazaId: 4,
  },
  {
    id: 9,
    name: 'جب جنين',
    cazaId: 5,
  },
  {
    id: 10,
    name: 'صغبين',
    cazaId: 5,
  },
  {
    id: 11,
    name: 'زحلة',
    cazaId: 6,
  },
  {
    id: 12,
    name: 'تعنايل',
    cazaId: 6,
  },
  {
    id: 13,
    name: 'جبيل',
    cazaId: 7,
  },
  {
    id: 14,
    name: 'عمشيت',
    cazaId: 7,
  },
  {
    id: 15,
    name: 'جونيه',
    cazaId: 8,
  },
  {
    id: 16,
    name: 'غازير',
    cazaId: 8,
  },
  {
    id: 17,
    name: 'عاليه',
    cazaId: 9,
  },
  {
    id: 18,
    name: 'بحمدون',
    cazaId: 9,
  },
  {
    id: 19,
    name: 'بعبدا',
    cazaId: 10,
  },
  {
    id: 20,
    name: 'الحدث',
    cazaId: 10,
  },
  {
    id: 21,
    name: 'بيت الدين',
    cazaId: 11,
  },
  {
    id: 22,
    name: 'دير القمر',
    cazaId: 11,
  },
  {
    id: 23,
    name: 'جديدة المتن',
    cazaId: 12,
  },
  {
    id: 24,
    name: 'بكفيا',
    cazaId: 12,
  },
  {
    id: 25,
    name: 'بنت جبيل',
    cazaId: 13,
  },
  {
    id: 26,
    name: 'عيترون',
    cazaId: 13,
  },
  {
    id: 27,
    name: 'حاصبيا',
    cazaId: 14,
  },
  {
    id: 28,
    name: 'شبعا',
    cazaId: 14,
  },
  {
    id: 29,
    name: 'مرجعيون',
    cazaId: 15,
  },
  {
    id: 30,
    name: 'القليعة',
    cazaId: 15,
  },
  {
    id: 31,
    name: 'النبطية',
    cazaId: 16,
  },
  {
    id: 32,
    name: 'الكفور',
    cazaId: 16,
  },
  {
    id: 33,
    name: 'البترون',
    cazaId: 17,
  },
  {
    id: 34,
    name: 'تنورين',
    cazaId: 17,
  },
  {
    id: 35,
    name: 'بشري',
    cazaId: 18,
  },
  {
    id: 36,
    name: 'الأرز',
    cazaId: 18,
  },
  {
    id: 37,
    name: 'أميون',
    cazaId: 19,
  },
  {
    id: 38,
    name: 'ضهر العين',
    cazaId: 19,
  },
  {
    id: 39,
    name: 'المنية',
    cazaId: 20,
  },
  {
    id: 40,
    name: 'سير الضنية',
    cazaId: 20,
  },
  {
    id: 41,
    name: 'طرابلس',
    cazaId: 21,
  },
  {
    id: 42,
    name: 'المينا',
    cazaId: 21,
  },
  {
    id: 43,
    name: 'زغرتا',
    cazaId: 22,
  },
  {
    id: 44,
    name: 'إهدن',
    cazaId: 22,
  },
  {
    id: 45,
    name: 'صيدا',
    cazaId: 23,
  },
  {
    id: 46,
    name: 'المية ومية',
    cazaId: 23,
  },
  {
    id: 47,
    name: 'جزين',
    cazaId: 24,
  },
  {
    id: 48,
    name: 'عاراي',
    cazaId: 24,
  },
  {
    id: 49,
    name: 'صور',
    cazaId: 25,
  },
  {
    id: 50,
    name: 'القاسمية',
    cazaId: 25,
  },
  {
    id: 51,
    name: 'بيروت',
    cazaId: 26,
  },
  {
    id: 52,
    name: 'الأشرفية',
    cazaId: 26,
  },
] as const;
